/**
 * Authors: mariushirjanu
 * Created: 03/06/2021
 */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'faq-popup-dialog',
  template:
    `<default-dialog [title]="title" [dialogClass]="dialogClass">
      <faq-item [faqId]="faqId" [faqCode]="faqCode"></faq-item>
    </default-dialog>`
})
export class FaqPopupDialogComponent {
  // dialog options
  @Input() public title:string;
  @Input() public faqId:number;
  @Input() public faqCode:string;
  @Input() public dialogClass:string;

  constructor() {
    /***/
  }
}